export const RQ_GET_UNLOCKING_HISTORY_API = {
  url:'reportingunlockhistory/dump/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};
